import { useSelector } from "react-redux";

import { Store } from "../session";
import { OpenShiftItem } from "../shift/model";

/**
 * Grabs the latest state of an open shift item from the redux state,
 * using the shift's ID
 */
export function useOpenShiftItem(shiftId: string): OpenShiftItem {
  const { openShiftItems = {} } = useSelector((store: Store) => store?.shiftStore ?? {});
  return openShiftItems[shiftId];
}
